import Vue from 'vue';
import Router from 'vue-router';
import './patch';
Vue.use(Router);
export default new Router({
	routes: [
		{
			path: '/',
			redirect: {name: 'home'}
		},
		{
			path: `/index`,
			name: `index`,
			meta: {
				keepAlive: true
			},
			component: resolve => {
				require(['@/page/index/index'], resolve);
			},

			children: [
				{
					path: `/home`,
					name: `home`,
					meta: {
						keepAlive: true
					},
					component: resolve => {
						require(['@/page/home/home'], resolve);
					}
				},

				{
					path: `/about`,
					name: `about`,
					meta: {
						keepAlive: true
					},
					component: resolve => {
						require(['@/page/about/about'], resolve);
					}
				},
				{
					path: `/success`,
					name: `success`,
					meta: {
						keepAlive: true
					},
					component: resolve => {
						require(['@/page/success/success'], resolve);
					}
				},
				{
					path: `/service`,
					name: `service`,
					meta: {
						keepAlive: true
					},
					component: resolve => {
						require(['@/page/service/service'], resolve);
					}
				},
				{
					path: `/scheme`,
					name: `scheme`,
					meta: {
						keepAlive: true
					},
					component: resolve => {
						require(['@/page/scheme/scheme'], resolve);
					}
				}
			]
		}
	]
});



// WEBPACK FOOTER //
// ./src/router/index.js